module.exports = __webpack_public_path__ + "img/molecule_line.c50d4f56.webp";